import { EGeoFocusActionType } from './types';
import { actionGenerator } from '../../../common/utils/redux/actionGenerator';

export const setAwaitingGeoFocus = actionGenerator<EGeoFocusActionType.SetAwaitingGeoFocus, boolean>(
  EGeoFocusActionType.SetAwaitingGeoFocus,
);
